module.exports = __webpack_public_path__ + "static/media/shape1.3f8220f0.svg";